import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-8"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Retour à l'accueil
        </button>

        <div className="bg-white rounded-xl shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>

          <div className="prose max-w-none">
            <h2>1. Introduction</h2>
            <p>
              ESTIM HABITAT s'engage à protéger votre vie privée et vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre service d'estimation immobilière.
            </p>

            <h2>2. Données collectées</h2>
            <p>Nous collectons les informations suivantes :</p>
            <ul>
              <li>Informations personnelles (nom, prénom, email, téléphone)</li>
              <li>Informations sur votre bien immobilier (adresse, caractéristiques)</li>
              <li>Données de navigation (cookies, adresse IP)</li>
            </ul>

            <h2>3. Utilisation des données</h2>
            <p>Vos données sont utilisées pour :</p>
            <ul>
              <li>Réaliser l'estimation de votre bien immobilier</li>
              <li>Vous contacter concernant votre estimation</li>
              <li>Améliorer nos services et algorithmes d'estimation</li>
              <li>Respecter nos obligations légales</li>
            </ul>

            <h2>4. Protection des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre tout accès, modification, divulgation ou destruction non autorisés.
            </p>

            <h2>5. Cookies</h2>
            <p>
              Nous utilisons des cookies pour améliorer votre expérience sur notre site. Ces cookies nous permettent de :
            </p>
            <ul>
              <li>Mémoriser vos préférences</li>
              <li>Analyser l'utilisation de notre site</li>
              <li>Personnaliser votre expérience</li>
            </ul>

            <h2>6. Vos droits</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul>
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité des données</li>
              <li>Droit d'opposition</li>
            </ul>

            <h2>7. Contact</h2>
            <p>
              Pour toute question concernant notre politique de confidentialité ou pour exercer vos droits, contactez-nous à :
            </p>
            <ul>
              <li>Email : contact@estimhabitat.com</li>
              <li>Téléphone : +33 7 80 90 00 00</li>
              <li>Adresse : Nice, France</li>
            </ul>

            <h2>8. Modifications</h2>
            <p>
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications prendront effet dès leur publication sur notre site.
            </p>

            <p className="text-sm text-gray-500 mt-8">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}